import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const featureBannerFields = `
  _id,
  _type,
  title,
  backgroundColor,
  items[]{
    title,
    image {
      ${imageFields}
    }
  }
`

export const FEATURE_BANNER_QUERY = defineQuery(/* groq */ `
  *[_type == "feature-banner"][0]{
    ${featureBannerFields}
  }
`)
